
export const GroupLabelRow = ({ groupLabel, numDataCols }: { groupLabel: string; numDataCols: number }) => (
    <tr className="NSTable__tbody__subheader">
        <td>{groupLabel}</td>
        {Array.from({ length: numDataCols }).map((_, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <td key={`empty-${idx}`} />
        ))}
    </tr>
);

export default GroupLabelRow;
